import { render, staticRenderFns } from "./technicalPersonnelInfo.vue?vue&type=template&id=b2ac3a94&scoped=true&"
import script from "./technicalPersonnelInfo.vue?vue&type=script&lang=js&"
export * from "./technicalPersonnelInfo.vue?vue&type=script&lang=js&"
import style0 from "./technicalPersonnelInfo.vue?vue&type=style&index=0&id=b2ac3a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac3a94",
  null
  
)

export default component.exports